<template>
  <div class="indexContainer">
    <div class="header">
      <div class="logo">
        <img
          src="@/assets/imgs/brandReview/logo.png"
          style="width:25px;height:25px;display:inline-block;margin-right:10px;"
          alt
        />
        <span>知圈圈</span>
      </div>
      <div class="tab" v-show="showTitleTab">
        <span @click="$router.push('/brandReview/brandController/myOrder')">费用</span>
        <span @click="$router.push('/brandReview/brandController/archivesRecheck')">控制台</span>
        <el-avatar :size="20" :src="circleUrl" style="margin-right:5px;position:relative;top:5px;"></el-avatar>
        <span v-if="username" style="margin-right:5px;">{{username}}</span>
        <span @click="$router.push('/')" v-else style="margin-right:5px;">登录</span>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link" style="color:#FFFFFF;">
            <i class="el-icon-arrow-down el-icon--right" style="color:#FFFFFF;"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="myMsg">个人中心</el-dropdown-item> -->
            <el-dropdown-item command="exit">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="contant">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { getCookie, removeCookie } from "@/utils/getToken.js";
import { logout } from "@/api/user";
export default {
  data() {
    return {
      active: 0,
      circleUrl: "",
      title: "驳回复审",
      showTitleTab: true,
      userpin: "",
      username: "",
    };
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        // 我的信息
        case "myMsg":
          break;
        // 退出登录
        case "exit":
          // console.log(userpin);
          logout(this.userpin).then((res) => {
            if (res.status == 0) {
              removeCookie("userpin");
              removeCookie("username");
              this.$message({
                message: "已退出登录！",
                type: "success",
              });
              this.$router.push("/");
            } else {
              this.$message.error("退出登录失败！");
            }
          });
          break;
      }
    },
    // 切换头部导航状态
    toogleTitleTab() {
      switch (this.$route.name) {
        case "rejectInformation":
          this.showTitleTab = false;
          break;
        case "applicantInformation":
          this.showTitleTab = false;
          break;
        case "agentInformation":
          this.showTitleTab = false;
          break;
        case "PFrejectInformation":
          this.showTitleTab = false;
          break;
        case "PFapplicantInformation":
          this.showTitleTab = false;
          break;
        case "PFagentInformation":
          this.showTitleTab = false;
          break;
        case "cashier":
          this.showTitleTab = false;
          break;
        case "payResult":
          this.showTitleTab = false;
          break;
        default:
          this.showTitleTab = true;
          break;
      }
    },
  },
  watch: {
    $route(newValue, oldValue) {
      if (newValue) {
        this.toogleTitleTab();
      }
    },
  },
  mounted() {},
  created() {
    this.toogleTitleTab();
    this.userpin = getCookie("userpin");
    this.username = getCookie("username");
    // //在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem("store") ) {
    //   this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    // } 
    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload",()=>{
    //   sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    // })
  },
};
</script>

<style lang = 'scss' scoped>
.indexContainer {
  background: #f4f4f4;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
  .header {
    /* width: 100%; */
    height: 50px;
    padding: 14px 0;
    background: #262f3e;
    font-family: PingFangSC-Semibold, PingFang SC;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
    .logo {
      height: 50px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
    }
    .tab {
      span {
        font-size: 12px;
        font-weight: 400;
        color: rgba(193, 198, 200, 1);
        display: inline-block;
        margin-right: 20px;
        height: 100%;
        line-height: 50px;
        cursor: pointer;
      }
      .active {
        color: rgba(255, 255, 255, 1);
      }
      .el-dropdown-link {
        cursor: pointer;
        color: #409eff;
        margin-right: 0;
        height: 50px;
        line-height: 50px;
        .el-avatar {
          margin-right: 0;
          position: relative;
          top: 50%;
          transform: translateY(-100%);
        }
      }
      .el-icon-arrow-down {
        font-size: 12px;
      }
    }
  }
  .contant {
    /* height: 100%; */
    position: absolute;
    box-sizing: border-box;
    top: 50px;
    bottom: 0;
    margin: 0;
    left: 0;
    right: 0;
    overflow: auto;
  }
}
</style>